import { render, staticRenderFns } from "./order_and_Delivery_Tracking.vue?vue&type=template&id=79fde628&scoped=true"
import script from "./order_and_Delivery_Tracking.vue?vue&type=script&lang=js"
export * from "./order_and_Delivery_Tracking.vue?vue&type=script&lang=js"
import style0 from "./order_and_Delivery_Tracking.vue?vue&type=style&index=0&id=79fde628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fde628",
  null
  
)

export default component.exports